<template>
    <ConfirmActionModal
        class="auction-confirm-winner"
        title="Подтвердить победителя"
        :on-confirm="onConfirmWinner"
    >
        <div class="auction-confirm-winner__bid">
            <div class="auction-confirm-winner__bid-title">Ставка победителя</div>
            <div class="auction-confirm-winner__bid-value">
                {{ numberFormat(winner.value) }} ₽
            </div>
        </div>

        <div class="entity-confirm-action">
            <div class="entity-confirm-action__title">Победитель</div>
            <div class="entity">
                <div class="entity__title">{{ winner.dealer_name }}</div>
                <div class="entity__list">
                    <div class="entity__list-item">
                        <div class="entity__list-label">Город:</div>
                        <div class="entity__list-value">{{ winner.dealer_city_name }}</div>
                    </div>
                    <div class="entity__list-item">
                        <div class="entity__list-label">Код дилера:</div>
                        <div class="entity__list-value">{{ winner.dealer_sap_code }}</div>
                    </div>
                    <div class="entity__list-item">
                        <div class="entity__list-label">Холдинг:</div>
                        <div class="entity__list-value">{{ winner.holding_name || '-' }}</div>
                    </div>
                </div>
            </div>
        </div>

        <UICheckbox
            v-model="formRulesAccepted"
            :error-message="formRulesAcceptedErrors.join()"
        >
            С <RulesLink>правилами аукциона</RulesLink> ознакомлен. Обязуемся оплатить вознаграждение за подготовку к сделке купли-продажи автомобиля.
        </UICheckbox>
    </ConfirmActionModal>
</template>

<script lang="ts" setup>
    import { PropType, ref } from 'vue';

    import { AuctionBid } from '@/types/auction/auction-bid.type.ts';

    import useAuctionRepository from '@/repositories/auction/useAuctionRepository.ts';

    import { numberFormat } from '@/utils/NumberFormatter.ts';

    import UICheckbox from '@/components/ui/UICheckbox/UICheckbox.vue';
    import ConfirmActionModal from '@/components/modals/ConfirmActionModal/ConfirmActionModal.vue';
    import RulesLink from '@/components/shared/RulesLink/RulesLink.vue';

    const { auctionId, winner } = defineProps({
        auctionId: {
            type: Number,
            required: true,
        },
        winner: {
            type: Object as PropType<AuctionBid>,
            required: true,
        },
    });

    const emit = defineEmits<{
        (e: 'confirmed'): void,
    }>();

    const { confirmAuctionWinner } = useAuctionRepository();

    const formRulesAccepted = ref<boolean>(false);
    const formRulesAcceptedErrors = ref<string[]>([]);

    async function onConfirmWinner(): Promise<string[] | undefined> {
        formRulesAcceptedErrors.value = [];

        if (!formRulesAccepted.value) {
            formRulesAcceptedErrors.value.push('Вы должны принять условия');

            return formRulesAcceptedErrors.value;
        }

        await confirmAuctionWinner(auctionId);
        emit('confirmed');
    }
</script>

<style scoped lang="scss">
    @use './AuctionConfirmWinner.scss' as *;
</style>
